import { render, staticRenderFns } from "./tiktok.vue?vue&type=template&id=2a05134f&scoped=true"
import script from "./tiktok.vue?vue&type=script&lang=js"
export * from "./tiktok.vue?vue&type=script&lang=js"
import style0 from "./tiktok.vue?vue&type=style&index=0&id=2a05134f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.38_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_gliqtm7r2yknapxh4mg6r2qyi4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a05134f",
  null
  
)

export default component.exports